import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {MxMaterialModule} from '../../material/mx-material.module';
import {MxSharedModule} from '../../shared/mx-shared.module';
import {MxButtonComponent} from './components/mx-button.component';

@NgModule({
    imports: [
        CommonModule,
        MxMaterialModule,
        MxSharedModule,
        TranslateModule
    ],
    exports: [MxButtonComponent],
    declarations: [MxButtonComponent]
})
export class MxButtonModule { }
